export default __webpack_public_path__ + "static/smart-ai-back-466e116fcaccbc7ab97a707a9b3b296a.webp";